/* ============================================================
   OBSIDIAN motion engine — no dependencies, defer-loaded.
   Reveal • Decode • Clocks • Seconds sweep • Tilt • Magnetic
   Progress • Ticker. Fully disabled under reduced motion.
   ============================================================ */
(function () {
  'use strict';

  var doc = document.documentElement;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  doc.classList.add('ob-js');
  if (reduced) doc.classList.add('ob-reduced');

  /* ---------- 1. REVEAL ENGINE ---------- */
  function autoTag() {
    var targets = document.querySelectorAll(
      '.product-card, .collection-card, .resource-card, ' +
      'main .section h2, main .section .h2, .ob-assure__cell'
    );
    targets.forEach(function (el) {
      if (!el.hasAttribute('data-obr')) el.setAttribute('data-obr', '');
    });
    // stagger index within each parent
    var parents = new Set();
    document.querySelectorAll('[data-obr]').forEach(function (el) {
      if (el.parentElement) parents.add(el.parentElement);
    });
    parents.forEach(function (parent) {
      var i = 0;
      Array.prototype.forEach.call(parent.children, function (child) {
        if (child.hasAttribute && child.hasAttribute('data-obr')) {
          child.style.setProperty('--obr-i', String(i % 8));
          i++;
        }
      });
    });
  }

  var io = null;
  function observeReveals() {
    if (reduced) return;
    if (!io) {
      io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('obr-in');
              io.unobserve(entry.target);
            }
          });
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
      );
    }
    document.querySelectorAll('[data-obr]:not(.obr-in)').forEach(function (el) {
      io.observe(el);
    });
  }

  /* ---------- 2. DECODE HEADLINES ---------- */
  var GLYPHS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789·—/';
  function decode(el) {
    if (reduced || el.dataset.obDecoded) return;
    el.dataset.obDecoded = '1';
    var finalText = el.textContent;
    var frame = 0;
    var totalFrames = Math.min(90, finalText.length * 3 + 24);
    el.style.visibility = 'visible';
    (function tick() {
      frame++;
      var resolved = Math.floor((frame / totalFrames) * finalText.length);
      var out = '';
      for (var i = 0; i < finalText.length; i++) {
        var ch = finalText[i];
        if (i < resolved || ch === ' ' || ch === '\n') out += ch;
        else out += GLYPHS[(Math.random() * GLYPHS.length) | 0];
      }
      el.textContent = out;
      if (frame < totalFrames) requestAnimationFrame(tick);
      else el.textContent = finalText;
    })();
  }

  function observeDecodes() {
    var els = document.querySelectorAll('[data-ob-decode]');
    if (!els.length) return;
    if (reduced) {
      els.forEach(function (el) { el.style.visibility = 'visible'; });
      return;
    }
    var dio = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          decode(entry.target);
          dio.unobserve(entry.target);
        }
      });
    }, { threshold: 0.4 });
    els.forEach(function (el) { dio.observe(el); });
  }

  /* ---------- 3. LIVE CLOCKS + SECONDS SWEEP ---------- */
  function startClocks() {
    var clocks = document.querySelectorAll('[data-ob-clock]');
    var sweeps = document.querySelectorAll('.ob-hero__seconds i');
    if (!clocks.length && !sweeps.length) return;

    function paint() {
      var now = new Date();
      clocks.forEach(function (el) {
        var tz = el.getAttribute('data-tz') || 'Asia/Dubai';
        try {
          el.textContent = new Intl.DateTimeFormat('en-GB', {
            hour: '2-digit', minute: '2-digit', second: '2-digit',
            hour12: false, timeZone: tz
          }).format(now);
        } catch (e) {
          el.textContent = now.toLocaleTimeString('en-GB', { hour12: false });
        }
      });
      var s = now.getSeconds() + now.getMilliseconds() / 1000;
      sweeps.forEach(function (el) {
        el.style.transform = 'scaleX(' + (s / 60).toFixed(4) + ')';
      });
    }
    paint();
    if (reduced) { setInterval(paint, 1000); return; }
    (function loop() { paint(); requestAnimationFrame(loop); })();
  }

  /* ---------- 4. CARD TILT + LIGHT SWEEP ---------- */
  function initTilt() {
    if (reduced || !finePointer) return;
    var MAX = 4; // degrees — restrained, machined
    document.addEventListener('pointermove', function (e) {
      var card = e.target.closest && e.target.closest('.product-card');
      if (!card) return;
      var r = card.getBoundingClientRect();
      var px = (e.clientX - r.left) / r.width;
      var py = (e.clientY - r.top) / r.height;
      card.style.setProperty('--ry', ((px - 0.5) * MAX * 2).toFixed(2) + 'deg');
      card.style.setProperty('--rx', ((0.5 - py) * MAX * 2).toFixed(2) + 'deg');
      card.style.setProperty('--mx', (px * 100).toFixed(1) + '%');
      card.style.setProperty('--my', (py * 100).toFixed(1) + '%');
    }, { passive: true });
    document.addEventListener('pointerout', function (e) {
      var card = e.target.closest && e.target.closest('.product-card');
      if (!card) return;
      card.style.setProperty('--rx', '0deg');
      card.style.setProperty('--ry', '0deg');
    }, { passive: true });
  }

  /* ---------- 5. MAGNETIC CTAS ---------- */
  function initMagnetic() {
    if (reduced || !finePointer) return;
    var PULL = 0.22, RADIUS = 90;
    document.querySelectorAll('.ob-hero .button, [data-ob-magnet]').forEach(function (btn) {
      btn.addEventListener('pointermove', function (e) {
        var r = btn.getBoundingClientRect();
        var dx = e.clientX - (r.left + r.width / 2);
        var dy = e.clientY - (r.top + r.height / 2);
        if (Math.hypot(dx, dy) < RADIUS + Math.max(r.width, r.height) / 2) {
          btn.style.transform =
            'translate(' + (dx * PULL).toFixed(1) + 'px,' + (dy * PULL).toFixed(1) + 'px)';
        }
      });
      btn.addEventListener('pointerleave', function () {
        btn.style.transform = '';
      });
    });
  }

  /* ---------- 6. SCROLL PROGRESS + HEADER STATE ---------- */
  function initScroll() {
    var bar = document.createElement('div');
    bar.className = 'ob-progress';
    bar.setAttribute('aria-hidden', 'true');
    document.body.appendChild(bar);
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var h = doc.scrollHeight - window.innerHeight;
        bar.style.transform = 'scaleX(' + (h > 0 ? window.scrollY / h : 0) + ')';
        document.body.classList.toggle('ob-scrolled', window.scrollY > 24);
        ticking = false;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- 7. SEAMLESS TICKER ---------- */
  function initTicker() {
    document.querySelectorAll('.ob-ticker__track').forEach(function (track) {
      if (track.dataset.obLooped) return;
      track.dataset.obLooped = '1';
      var original = track.innerHTML;
      // duplicate until track is at least 2x viewport for a clean -50% loop
      var guard = 0;
      while (track.scrollWidth < window.innerWidth * 2 && guard < 8) {
        track.innerHTML += original;
        guard++;
      }
      track.innerHTML += track.innerHTML; // final mirror for the -50% keyframe
    });
  }

  /* ---------- BOOT ---------- */
  function boot() {
    autoTag();
    observeReveals();
    observeDecodes();
    startClocks();
    initTilt();
    initMagnetic();
    initScroll();
    initTicker();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-run lightweight passes when Shopify section editor or
  // dynamic content (filters, pagination) swaps DOM in.
  var mo = new MutationObserver(function () {
    clearTimeout(mo._t);
    mo._t = setTimeout(function () {
      autoTag();
      observeReveals();
      initTicker();
    }, 120);
  });
  mo.observe(document.body || doc, { childList: true, subtree: true });

  document.addEventListener('shopify:section:load', boot);
})();

/* ============================================================
   OBSIDIAN motion engine — PART II
   Word illumination • Counters • Parallax • Craft scrollytelling
   • model-viewer lazy loader
   ============================================================ */
(function () {
  'use strict';

  var doc = document.documentElement;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- 8. WORD ILLUMINATION (manifesto) ---------- */
  function splitWords(root) {
    if (root.dataset.obSplit) return;
    root.dataset.obSplit = '1';
    function walk(node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (child) {
        if (child.nodeType === 3) {
          var frag = document.createDocumentFragment();
          child.textContent.split(/(\s+)/).forEach(function (piece) {
            if (!piece) return;
            if (/^\s+$/.test(piece)) {
              frag.appendChild(document.createTextNode(piece));
            } else {
              var span = document.createElement('span');
              span.className = 'ob-w';
              span.textContent = piece;
              frag.appendChild(span);
            }
          });
          node.replaceChild(frag, child);
        } else if (child.nodeType === 1) {
          walk(child);
        }
      });
    }
    walk(root);
  }

  function initWords() {
    var blocks = document.querySelectorAll('[data-ob-words]');
    if (!blocks.length || reduced) return;
    blocks.forEach(splitWords);

    var ticking = false;
    function paint() {
      blocks.forEach(function (block) {
        var words = block.querySelectorAll('.ob-w');
        if (!words.length) return;
        var r = block.getBoundingClientRect();
        var vh = window.innerHeight;
        // progress: 0 when block top hits 85% viewport, 1 when bottom passes 45%
        var start = vh * 0.85;
        var end = vh * 0.45;
        var total = (r.height + (start - end));
        var progress = (start - r.top) / total;
        progress = Math.max(0, Math.min(1, progress));
        var lit = Math.round(progress * words.length);
        for (var i = 0; i < words.length; i++) {
          words[i].classList.toggle('on', i < lit);
        }
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(paint); }
    }, { passive: true });
    paint();
  }

  /* ---------- 9. COUNTERS ---------- */
  function animateCount(el) {
    var target = parseFloat(el.getAttribute('data-ob-count')) || 0;
    if (reduced) { el.textContent = String(target); return; }
    var dur = 1400, t0 = null;
    function step(t) {
      if (!t0) t0 = t;
      var p = Math.min(1, (t - t0) / dur);
      var eased = 1 - Math.pow(1 - p, 4);
      el.textContent = String(Math.round(target * eased));
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function initCounters() {
    var els = document.querySelectorAll('[data-ob-count]');
    if (!els.length) return;
    if (reduced) { els.forEach(animateCount); return; }
    var cio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { animateCount(e.target); cio.unobserve(e.target); }
      });
    }, { threshold: 0.6 });
    els.forEach(function (el) { cio.observe(el); });
  }

  /* ---------- 10. PARALLAX (story imagery) ---------- */
  function initParallax() {
    if (reduced) return;
    var els = document.querySelectorAll('[data-ob-parallax]');
    if (!els.length) return;
    var RANGE = 26; // px, restrained
    var ticking = false;
    function paint() {
      var vh = window.innerHeight;
      els.forEach(function (img) {
        var r = img.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var mid = r.top + r.height / 2;
        var offset = ((mid - vh / 2) / (vh / 2)) * -RANGE;
        img.style.setProperty('--par', offset.toFixed(1) + 'px');
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(paint); }
    }, { passive: true });
    paint();
  }

  /* ---------- 11. CRAFT SCROLLYTELLING ---------- */
  function initCraft() {
    document.querySelectorAll('[data-ob-craft]').forEach(function (section) {
      var steps = section.querySelectorAll('[data-ob-step]');
      var imgs = section.querySelectorAll('[data-ob-craft-img]');
      var num = section.querySelector('[data-ob-craft-num]');
      if (!steps.length) return;

      function activate(index) {
        steps.forEach(function (s, i) { s.classList.toggle('is-active', i === index); });
        imgs.forEach(function (im, i) { im.classList.toggle('is-active', i === index); });
        if (num) num.textContent = ('0' + (index + 1)).slice(-2);
      }
      activate(0);

      var sio = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            var idx = Array.prototype.indexOf.call(steps, e.target);
            if (idx > -1) activate(idx);
          }
        });
      }, { rootMargin: '-42% 0px -42% 0px', threshold: 0 });
      steps.forEach(function (s) { sio.observe(s); });
    });
  }

  /* ---------- 12. MODEL-VIEWER LAZY LOADER ---------- */
  function initModelViewer() {
    if (!document.querySelector('model-viewer')) return;
    if (window.customElements && window.customElements.get('model-viewer')) return;
    var s = document.createElement('script');
    s.type = 'module';
    s.src = 'https://ajax.googleapis.com/ajax/libs/model-viewer/3.5.0/model-viewer.min.js';
    document.head.appendChild(s);

    // wire the progress hairline
    document.addEventListener('progress', function (e) {
      var mv = e.target;
      if (mv && mv.tagName === 'MODEL-VIEWER' && e.detail && typeof e.detail.totalProgress === 'number') {
        var bar = mv.querySelector('.ob-3d__progress i');
        if (bar) bar.style.setProperty('--ob-3d-p', String(e.detail.totalProgress));
        if (e.detail.totalProgress >= 1) {
          var wrap = mv.querySelector('.ob-3d__progress');
          if (wrap) wrap.style.opacity = '0';
        }
      }
    }, true);
  }

  /* ---------- BOOT II ---------- */
  function boot2() {
    initWords();
    initCounters();
    initParallax();
    initCraft();
    initModelViewer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot2);
  } else {
    boot2();
  }
  document.addEventListener('shopify:section:load', boot2);
})();
